import axios from "axios";
import { ICityPage, ICityPageConfigCreateDto, ICityPageSectionEditDto, ICityPageStatistics } from "../interfaces/endpoints/ICityPage";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { IPagination } from "../interfaces/IPagination";
import { serialize } from "../utils/serializeToQueryString";

export const getCityPageById = async (
  id: string
): Promise<IAxiosResponse<ICityPage>> => {
  return axios.get<ICityPage>(`CityPage/${id}`);
};

export const getAllCityPages = async (
  att: { search?: string; pageIndex?: number; pageSize?: number }
): Promise<IAxiosResponse<IPagination<ICityPage>>> => {
  const query = serialize({ ...att });
  return axios.get<IPagination<ICityPage>>(`CityPage${query}`);
};

export const createMissingCityPages = async (): Promise<IAxiosResponse<void>> => {
  return axios.post("CityPage/CreateMissing");
};

export const createCityPageForCity = async (
  cityId: number
): Promise<IAxiosResponse<ICityPage>> => {
  return axios.post<ICityPage>(`CityPage/CreateForCity/${cityId}`);
};

export const getCityPageSections = async (
  cityPageId: number
): Promise<IAxiosResponse<ICityPageSectionEditDto[]>> => {
  return axios.get<ICityPageSectionEditDto[]>(`/CityPage/${cityPageId}/Sections`);
};

export const editCityPageSections = async (
  cityPageId: number,
  data: ICityPageSectionEditDto[]
): Promise<IAxiosResponse<number>> => {
  return axios.post<number>(`/CityPage/${cityPageId}/Sections`, data);
};

export const getCityPageStatistics = async (
  cityPageId: number
): Promise<IAxiosResponse<ICityPageStatistics>> => {
  return axios.get<ICityPageStatistics>(`/CityPage/${cityPageId}/Statistics`);
};

export const updateCityPageStatistics = async (
  cityPageId: number,
  data: ICityPageStatistics
): Promise<IAxiosResponse<number>> => {
  return axios.put<number>(`/CityPage/${cityPageId}/Statistics`, data);
};

export const getCityPageConfig = async (
  cityPageId: number
): Promise<IAxiosResponse<ICityPageConfigCreateDto>> => {
  return axios.get<ICityPageConfigCreateDto>(`/CityPage/${cityPageId}/Config`);
};

export const updateCityPageConfig = async (
  cityPageId: number,
  data: ICityPageConfigCreateDto
): Promise<IAxiosResponse<number>> => {
  return axios.put<number>(`/CityPage/${cityPageId}/Config`, data);
};

export const regenerateCityPage = async (
  cityPageId: number
): Promise<IAxiosResponse<number>> => {
  return axios.get<number>(`/CityPage/${cityPageId}/Regenerate`);
};

export const toggleCityPageEnabled = async (
  cityPageId: number
): Promise<IAxiosResponse<boolean>> => {
  return axios.put<boolean>(`/CityPage/${cityPageId}/ToggleEnabled`);
};
